import React from 'react';
import { Text, Flex, Img } from 'pounceV2';
import NothingFound from 'Assets/illustrations/nothing-found.svg';
import { useTheme } from '@mui/material';

interface NoResultsFoundProps {
  title?: string;
}

const NoResultsFoundV3: React.FC<NoResultsFoundProps> = ({ title = 'No Results' }) => {
  const { palette } = useTheme();
  return (
    <Flex justify="center" data-dd-privacy="allow">
      <Flex
        direction="column"
        align="center"
        justify="center"
        borderRadius="circle"
        width={260}
        height={260}
        backgroundColor={palette.tokens.background.neutral.mid[2]}
      >
        <Img
          ml={6}
          nativeWidth={95}
          nativeHeight={90}
          alt="Document and magnifying glass"
          src={NothingFound}
        />
        <Text variant="body/lg" fontWeight="semibold" mt={2}>
          {title}
        </Text>
      </Flex>
    </Flex>
  );
};

export default NoResultsFoundV3;
